import { useEffect } from "react";
import { Toaster } from "sonner";
import { useTranslation } from "react-i18next";
import { getToastPosition, getDirection } from "@shared/utils/rtl";

const ToastProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const toastPosition = getToastPosition(currentLanguage);
  const direction = getDirection(currentLanguage);

  // Apply direction to document when language changes
  useEffect(() => {
    document.documentElement.dir = direction;
  }, [direction]);

  return (
    <>
      {children}
      <Toaster
        position={toastPosition}
        dir={direction}
        toastOptions={{
          style: {
            direction: direction,
          },
          className: direction === "rtl" ? "rtl-toast" : "ltr-toast",
        }}
        expand={true}
        visibleToasts={5}
        duration={4000}
        closeButton={true}
        richColors={true}
      />
    </>
  );
};

export default ToastProvider;
